var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "green-operation-assessment",
      class: { "is-edit": _vm.isEdit },
    },
    [
      _c("HKLLeftRight", {
        staticClass: "green-operation-assessment__header",
        scopedSlots: _vm._u(
          [
            {
              key: "left",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "green-operation-letter__filter-bar align-middle",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "green-operation-letter__filter-label" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("showLabel")) +
                              ":\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "green-operation-letter__filter-selector",
                        },
                        [
                          _c("HKLSelect", {
                            staticClass: "no-border flex-theme",
                            attrs: {
                              showArrow: !_vm.isEdit,
                              value: _vm.selectedLetterId,
                              options: _vm.letterOptions,
                              open: _vm.isEdit ? false : undefined,
                            },
                            on: { select: _vm.selectLetter },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            _vm.isCurrentLetter && !_vm.readonly
              ? {
                  key: "right",
                  fn: function () {
                    return [
                      _vm.isEdit
                        ? [
                            _c("HKLButton", {
                              attrs: { color: "darkblue", action: "cancel" },
                              on: {
                                click: function () {
                                  return _vm.cancel()
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("HKLButton", {
                              attrs: { color: "orange", action: "save" },
                              on: {
                                click: function () {
                                  return _vm.save()
                                },
                              },
                            }),
                          ]
                        : [
                            _vm.canReview
                              ? _c("HKLButton", {
                                  attrs: { color: "orange", action: "edit" },
                                  on: {
                                    click: function () {
                                      return _vm.setEdit(true)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c(
        "HKLForm",
        { ref: "form" },
        _vm._l(_vm.assessmentComponents, function (componentVue, index) {
          return _c(componentVue, { key: index, tag: "component" })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }